import React from 'react';
import { Clock, Zap } from 'lucide-react';

/**
 * Coming Soon Badge Component
 * Shows roadmap velocity - features in development
 */
export const ComingSoonBadge = ({ size = 'sm', variant = 'default', showIcon = true }) => {
  const sizeClasses = {
    xs: 'text-[10px] px-1.5 py-0.5',
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-2.5 py-1.5',
    lg: 'text-base px-3 py-2',
  };

  const variantClasses = {
    default: 'bg-purple-500/20 border-purple-500/40 text-purple-300',
    soon: 'bg-blue-500/20 border-blue-500/40 text-blue-300',
    beta: 'bg-orange-500/20 border-orange-500/40 text-orange-300',
    new: 'bg-green-500/20 border-green-500/40 text-green-300 animate-pulse-slow',
  };

  const labels = {
    default: 'Coming Soon',
    soon: 'Coming Soon',
    beta: 'Beta',
    new: 'New',
  };

  return (
    <div
      className={`inline-flex items-center gap-1 rounded-full border ${variantClasses[variant]} ${sizeClasses[size]} font-semibold`}
      data-testid="coming-soon-badge"
    >
      {showIcon && variant === 'default' && <Clock className="w-3 h-3" />}
      {showIcon && variant === 'new' && <Zap className="w-3 h-3" />}
      <span>{labels[variant]}</span>
    </div>
  );
};

/**
 * Feature Card with Coming Soon
 * Displays a feature card with coming soon badge
 */
export const FeatureCardComingSoon = ({ title, description, icon: Icon, variant = 'default', onClick }) => {
  return (
    <div
      className="relative group bg-[#0E1426]/50 border border-[#22304A] rounded-lg p-6 hover:border-purple-500/40 transition-all cursor-pointer"
      onClick={onClick}
      data-testid="feature-card-coming-soon"
    >
      {/* Coming Soon Badge */}
      <div className="absolute top-4 right-4">
        <ComingSoonBadge size="sm" variant={variant} />
      </div>

      {/* Icon */}
      {Icon && (
        <div className="w-12 h-12 rounded-lg bg-[#22304A] flex items-center justify-center mb-4 group-hover:bg-purple-500/20 transition-colors">
          <Icon className="w-6 h-6 text-purple-400" />
        </div>
      )}

      {/* Content */}
      <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-purple-300 transition-colors">
        {title}
      </h3>
      <p className="text-sm text-gray-400">
        {description}
      </p>

      {/* Hover Effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-500/5 to-blue-500/5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
    </div>
  );
};

export default ComingSoonBadge;
